import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { EchoTokenService } from '../../services';

export const tokenEchoInterceptor: HttpInterceptorFn = (req, next) => {
  const echoTokenService = inject(EchoTokenService);

  const echoToken = echoTokenService.getToken();

  if (!echoToken) {
    return next(req);
  }

  const modified = req.clone({
    setHeaders: {
      'innership-echo-token': echoToken
    }
  });

  return next(modified);
};
